import React, { useEffect, useState, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";

import _ from "lodash";
import Inprogressticket from "../../../../../../../Assets/AppComponent/Union (28).svg";
import reviewticker from "../../../../../../../Assets/AppComponent/Union (31).svg";

import reopenticketslist from "../../../../../../../Assets/AppComponent/Union (33).svg";
import resolvedticket from "../../../../../../../Assets/AppComponent/Union (34).svg";
import Cardimgs from "../../../../../../../Assets/AppComponent/Union (27).svg";



export const TicketCards = (
  {activeButton ,
    setActiveButton ,
    handleButtonClick
  }
) => {
    const dispatch = useDispatch();
    const state = useSelector((state) => state)
    const DashboardDatas = useSelector((state) => state.TicketingInertnalDashboardCalls.TicketingInternalDashboarddata)



  return (
    <>
      <div className="Inner_TicketsListed">
           <div className="row mt-3 ticket-dashboard">
          <div className="row Ticketdetails">
            <div className=" Innerticket-dashboard text-center">


              <div
                className={`col-md-4 CardDesigns mb-3 ${activeButton === "Open" ? "active-card" : ""
                  }`}
                onClick={() => handleButtonClick("Open")}
              >
                <div className="card p-3">
                  <div className="InnercardImgData InnercardImgDataTicketcreate">
                    <span className="FrstCard">
                      <img src={Cardimgs} alt="Card Icon" />
                    </span>
                    <h2>{DashboardDatas.open_ticketing_count || 0}</h2>
                  </div>
                  <h5>Open Tickets</h5>
                </div>
              </div>

              <div
                className={`col-md-4 CardDesigns mb-3 ${activeButton === "In Progress" ? "active-card" : ""
                  }`}
                onClick={() => handleButtonClick("In Progress")}
              >
                <div className="card p-3">
                  <div className="InnercardImgData">
                    <span className="secondCard">
                      <img src={Inprogressticket} alt="Card Icon" />
                    </span>
                    <h2>{DashboardDatas.inprocess_ticketing_count || 0}</h2>
                  </div>
                  <h5>In Progress Tickets</h5>
                </div>
              </div>

              <div
                className={`col-md-4 mb-3 ${activeButton === "Review" ? "active-card" : ""
                  }`}
                onClick={() => handleButtonClick("Review")}
              >
                <div className="card p-3">
                  <div className="InnercardImgData">
                    <span className="threeCard">
                      <img src={reviewticker} alt="Card Icon" />
                    </span>
                    <h2>{DashboardDatas.review_tickets_count || 0}</h2>
                  </div>
                  <h5>Review Tickets</h5>
                </div>
              </div>

              <div
                className={`col-md-4 mb-3 ${activeButton === "Reopen" ? "active-card" : ""
                  }`}
                onClick={() => handleButtonClick("Reopen")}
              >
                <div className="card p-3">
                  <div className="InnercardImgData">
                    <span className="fourCard">
                      <img src={reopenticketslist} alt="Card Icon" />
                    </span>
                    <h2>{DashboardDatas.reopen_ticketing_count || 0}</h2>
                  </div>
                  <h5>Reopened Tickets</h5>
                </div>
              </div>

              <div
                className={`col-md-4 mb-3 ${activeButton === "Resolved" ? "active-card" : ""
                  }`}
                onClick={() => handleButtonClick("Resolved")}
              >
                <div className="card p-3">
                  <div className="InnercardImgData">
                    <span className="fiveCard">
                      <img src={resolvedticket} alt="Card Icon" />
                    </span>
                    <h2>{DashboardDatas.resolved_tickets || 0}</h2>
                  </div>
                  <h5>Resolved Tickets</h5>
                </div>
              </div>
            </div>
          </div>
        </div>

        </div>

    </>
  )
}
